import script from "./DomainConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./DomainConfig.vue?vue&type=script&lang=ts&setup=true"

import "./DomainConfig.vue?vue&type=style&index=0&id=16a03106&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a03106"]])

export default __exports__